"use client";
import SurveyQna from "@/app/survey/SurveyQna";
import { useRouter } from "next/navigation";
import SurveyAnalytics from "@/app/survey/SurveyAnalytics";
import SurveyBannerSection from "../../SurveyBannerSection";
interface Props {
  survey: any;
  id: string;
  surveySummary: any;
}
export default function SurveyDetailClient({ survey, surveySummary, id }: Props) {
  const router = useRouter();
  const surveyId = Number(id);
  const handlePrev = () => {
    if (surveyId > 1) {
      router.push(`/survey/index/${surveyId - 1}`);
    }
  };

  const handleNext = () => {
    router.push(`/survey/index/${surveyId + 1}`);
  };
  return (
    <>
      <SurveyBannerSection survey={survey} handlePrev={handlePrev} handleNext={handleNext} surveyId={surveyId} />
      <SurveyAnalytics survey={survey} />
      <SurveyQna sections={surveySummary} />
    </>
  );
}
